// Pages that open with the home page's photo story hero instead of the standard
// page hero. Keyed by page path. The title lines must read as the page's h1.

export interface StoryHeroContent {
    titleLines: string[]
    image: string
    imagePosition?: string
    note: string
    statement: string
}

export const STORY_HEROES: Record<string, StoryHeroContent> = {
    '/windows-doors/': {
        titleLines: ["Exterior Windows and Doors", "in North Alabama"],
        image: 'hero-windows-doors',
        note: "Exterior windows and exterior doors only. Nothing inside the house.",
        statement: "More light, less draft, and a front door that closes the way it should. Measured, fitted and sealed with care, then cleaned up before we leave."
    },
    '/services/window-replacement/': {
        titleLines: ["Exterior Window Replacement", "in North Alabama"],
        image: 'hero-window-replacement',
        note: "Replacement windows for North Alabama homes, fitted from the outside.",
        statement: "We measure every opening, check the framing behind the old window, and seal the new one against long, humid summers."
    },
    '/services/door-installation/': {
        titleLines: ["Exterior Door Installation", "in North Alabama"],
        image: 'hero-door-installation',
        note: "Entry, patio, French and storm doors. Exterior doors only.",
        statement: "A front door should close with one hand, seal out the weather and look like it belongs on your home."
    },
    '/services/siding/': {
        titleLines: ["Siding in", "North Alabama"],
        image: 'hero-siding',
        note: "Siding, house wrap and the moisture details behind them.",
        statement: "In this humidity, what sits behind your siding matters as much as the siding itself. That is where we start."
    },
    '/services/roofing/': {
        titleLines: ["Roofing in", "North Alabama"],
        image: 'hero-roofing',
        imagePosition: 'center 40%',
        note: "Full tear-off, a checked deck and proper attic ventilation.",
        statement: "A roof is only as good as what sits under it. We check the deck, repair what we find and let the attic breathe."
    },
    '/services/pressure-washing/': {
        titleLines: ["Pressure and Soft Washing", "in North Alabama"],
        image: 'hero-pressure-washing',
        note: "The pressure matched to the surface, not to the machine.",
        statement: "Soft washing for siding and roofs, real pressure for concrete. Clean surfaces without the damage a heavy wand can do."
    }
}
